import { MenuDataService } from './../services/menu-data.service';
import { Directive, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ItemMenuModel } from '../models/ItemMenuModel';

@Directive({
	selector: '[actionPermission]'
})
export class ButtonActionsDirective {

	@Input() actionPermission: string = "";

	@Output('callback') Callback: EventEmitter<Array<any>> = new EventEmitter();

	private El: ElementRef;

	constructor(
		private el: ElementRef,
		private router: Router,
		private menuDataService: MenuDataService
	) {
		this.El = el;

	}

	ngOnInit() {

		// if (url.includes('/details')) {
		// 	menu = this.MenuDataService.GetMenuByPath(url.split('/details')[0], 'ACCESS_DETAILS');
		// }
		// else if(url.includes('/validation')) {
		// 	menu = this.MenuDataService.GetMenuByPath(url.split('/validation')[0], 'ACCESS_VALITATION');
		// }
		const route = this.router.url.split('?')[0];

		//PASSA A ACEITAR MAIS DO QUE UMA PERMISSÃO PARA CASOS DE MODALS QUE TÊM A MESMA AÇÃO EM MENUS DIFERENTES (POR EX: DECISÕES NOS DETALHES DAS PROPOSTAS)
		const actionPermission = this.actionPermission?.toString();
		const actionPermissionsArr: Array<string> = actionPermission ? actionPermission.includes(',') ? actionPermission.split(',') : [actionPermission] : [];

		if (this.router.url && route) {

			let menuName: string = null;
			const Actions = [];

			// VERIFICAR ENTRADAS
			['/details', '/validation'].forEach(el => {
				if (route.includes(el)) {
					menuName = route.split(el)[0];
				}
			})

			// console.log(route, menuName);
			const menu: ItemMenuModel = this.menuDataService.GetMenuByPath(menuName ? menuName : route);
			if (menu && menu.Actions.length >= 0) {
				let countPermission = 0;
				for (let index = 0; index < menu.Actions.length; index++) {
					Actions.push(menu.Actions[index]);
					// if (this.actionPermission && parseInt(this.actionPermission) === menu.Actions[index].Id) {
					// 	countPermission++;
					// 	break;
					// }

					if (actionPermissionsArr && actionPermissionsArr.length > 0) {
						actionPermissionsArr.forEach(a => {
							if (parseInt(a) === menu.Actions[index].Id) {
								countPermission++;
							}
						})

						// break;
					}
				}

				if (countPermission === 0 && this.actionPermission) {
					this.El.nativeElement.remove();
				}
			}
			else {
				console.log("without permissions");
				// analizar situação
				// this.menuDataService.
				this.El.nativeElement.remove();
				return;
			}

			if (!this.actionPermission && this.Callback) {

				this.Callback.emit(Actions);


			}
		}
	}
}
